import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  Stack,
  Divider,
} from "@mui/material";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import Avatar from "../../assets/img/avatar.png";

const formatConfidence = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num.toFixed(2) : "-";
};

const ImageCard = ({
  photo,
  onCompare,
  onZoom,
  onRetake,
  onScore,
  showRetakeButton = false,
  showScoreButton = false,
  canRetake = false,
  canScore = false,
  canZoom = true,
  showConfidence = false,
}) => {
  return (
    <Card variant="outlined">
      {/* Image */}
      <Box
        component="img"
        src={photo.image || Avatar}
        alt={photo.photo_type?.name_str || "Photo"}
        sx={{
          width: "100%",
          height: 220,
          objectFit: "cover",
          cursor: "pointer",
        }}
        onClick={onCompare}
      />

      <CardContent sx={{ pb: 1.5 }}>
        {/* Photo meta */}
        <Typography variant="subtitle2" fontWeight={600} noWrap>
          {photo.photo_type?.name_str}
        </Typography>

        <Typography variant="caption" color="text.secondary">
          {new Date(photo.captured_at + "Z").toLocaleString()}
        </Typography>

        {/* AI Scores */}
        {photo?.ai_scores?.some((s) => s.score !== null && s.score !== undefined) && (
          <>
            <Divider sx={{ my: 1 }} />

            <Stack spacing={0.75}>
              {photo.ai_scores.map((score) => {
                if (score.score == null) return null;

                return (
                  <Stack spacing={0.25} key={score.area}>
                    <Typography variant="caption" color="text.secondary">
                      {score.area} AI Score: {score.score}
                    </Typography>

                    {showConfidence && score.confidence != null && (
                      <Typography variant="caption" color="text.secondary">
                        Confidence: {formatConfidence(score.confidence)}
                      </Typography>
                    )}
                  </Stack>
                );
              })}
            </Stack>
          </>
        )}
      </CardContent>

      <CardActions sx={{ pb: 1.5, flexDirection: "column", alignItems: "stretch" }}>
        {showScoreButton && (
          <Button
            variant="contained"
            startIcon={<AssignmentTurnedInOutlinedIcon />}
            disabled={!canScore}
            onClick={onScore}
            sx={{ mb: 1 }}
          >
            Score in eCRF
          </Button>
        )}

        <Stack direction="row" justifyContent="space-around">
          <Button size="small" onClick={onZoom} disabled={!canZoom}>
            Zoom
          </Button>

          {showRetakeButton && (
            <Button size="small" color="error" disabled={!canRetake} onClick={onRetake}>
              Re-Take
            </Button>
          )}
        </Stack>
      </CardActions>
    </Card>
  );
};

export default ImageCard;
